<template>
    <div class="exception-body access">
        <div class="exception-content">
            <div class="exception-title">{{$t('common.access_denied.title')}}</div>
            <div class="exception-detail">{{$t('common.access_denied.detail')}}</div>
            <a href="/">{{$t('common.access_denied.link')}}</a>
        </div>
    </div>
</template>

<script>
export default {};
</script>
